// @ts-check
// ====== Versioning client + reload prompt ======
// Polling periodico del manifest Vite per rilevare nuovi deploy.
// Quando rileva che il bundle è cambiato, mostra un banner "Nuova versione,
// ricarica" cliccabile. Non forza il reload — l'utente decide quando.

const VERSION_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minuti
const VERSION_CHECK_URL = '/index.html';

let _currentHash = null;
let _watchTimer = null;

async function fetchCurrentBundleHash() {
  try {
    const r = await fetch(VERSION_CHECK_URL, { cache: 'no-store' });
    if (!r.ok) return null;
    const html = await r.text();
    // Estrai il path del bundle Vite hashato es. /assets/index-CeRrCJN_.js
    const m = html.match(/\/assets\/index-([a-zA-Z0-9_-]+)\.js/);
    return m ? m[1] : null;
  } catch {
    return null;
  }
}

function showUpdateBanner() {
  if (document.getElementById('versionUpdateBanner')) return;
  const banner = document.createElement('div');
  banner.id = 'versionUpdateBanner';
  banner.className = 'version-update-banner';
  banner.innerHTML = `
    <span>🚀 <strong>Nuova versione disponibile</strong> — ricarica per vederla</span>
    <button class="btn btn-sm btn-primary" id="versionReloadBtn">Ricarica ora</button>
    <button class="btn btn-sm" id="versionDismissBtn">Più tardi</button>
  `;
  document.body.appendChild(banner);
  document.getElementById('versionReloadBtn').addEventListener('click', () => location.reload());
  document.getElementById('versionDismissBtn').addEventListener('click', () => banner.remove());
}

async function checkVersion() {
  const hash = await fetchCurrentBundleHash();
  if (!hash) return; // niente bundle hashato (dev mode o errore)
  if (_currentHash === null) {
    _currentHash = hash;
    return;
  }
  if (hash !== _currentHash) {
    showUpdateBanner();
    if (_watchTimer) {
      clearInterval(_watchTimer);
      _watchTimer = null;
    }
  }
}

function startVersionWatch() {
  if (_watchTimer) return;
  // Primo check immediato per inizializzare _currentHash
  checkVersion();
  _watchTimer = setInterval(checkVersion, VERSION_CHECK_INTERVAL);
  // Anche quando la tab torna in foreground, controlla
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkVersion();
  });
}

function stopVersionWatch() {
  if (_watchTimer) {
    clearInterval(_watchTimer);
    _watchTimer = null;
  }
}

Object.assign(globalThis, { startVersionWatch, stopVersionWatch, checkVersion });
export {};
